import React, {Component} from 'react';
// import Oidc from 'oidc-client';

class Refresh extends Component {
  componentDidMount() {
    // new Oidc.UserManager().signinSilentCallback().then(() => {
    //   manager
    //     .getUser()
    //     .then(user => {
    //       if (user) {
    //         user = JSON.stringify(user);
    //         localStorage.setItem('user', user);
    //       } else {
    //         manager.signinRedirect();
    //       }
    //     })
    //     .catch(() => {
    //       manager.signinRedirect();
    //     });
    // });
  }

  render() {
    return <div />;
  }
}

export default Refresh;
